module.exports = __webpack_public_path__ + "img/xxh.c4a68a12.png";